export const FETCH_PRODUCTS_TO_COMPARE_BEGIN = 'FETCH_PRODUCTS_TO_COMPARE_BEGIN';
export const FETCH_PRODUCTS_TO_COMPARE_SUCCESS = 'FETCH_PRODUCTS_TO_COMPARE_SUCCESS';
export const FETCH_PRODUCTS_TO_COMPARE_FAILURE = 'FETCH_PRODUCTS_TO_COMPARE_FAILURE';
export const RESET_PRODUCTS_TO_COMPARE = 'RESET_PRODUCTS_TO_COMPARE';